import {gsap} from "../lib/gsap";
import {ScrollTrigger} from "../lib/gsap/ScrollTrigger";
import {ScrollSmoother} from "../lib/gsap/ScrollSmoother";
import {SplitText} from "../lib/gsap/SplitText";
import {Observer} from "../lib/gsap/Observer";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, Observer);

export {ScrollTrigger};
export {ScrollSmoother};
export {SplitText};
export {Observer};
export {gsap};


